export const DRONES_PAGE_SIZE = 10;
